/* ============
 * creditNoteReason Module Mutations
 * ============
 */

import {
  FETCH_ALL_CREDIT_NOTE_REASONS,
  FETCH_CURRENT_CREDIT_NOTE_REASON,
} from './../../mutation-types';

export default {
  [FETCH_ALL_CREDIT_NOTE_REASONS](state, creditNoteReasons) {
    state.all = creditNoteReasons;
  },

  [FETCH_CURRENT_CREDIT_NOTE_REASON](state, creditNoteReason) {
    state.current = creditNoteReason;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/creditNoteReason/mutations.js